import { OffersService } from './offers';
import { TariffType } from '../../schema';

export async function findOneByComponentSet (set: Array<any>): Promise<any> {
    return OffersService.findOneByComponentSet(set);
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/offers/offers.find-one-by-component-set.ts